import React, { useEffect } from 'react';
import { Card, Box, Stack } from '@curves/ui-base';
import { localUser } from '@Util/utils';
import { MemberUserBox } from '@Local/Member/Components';
import { BarcodeGenerator } from '@Local/Components/';
import { useMainLayoutContext } from "@Local/Components/Layout/Context/MainLaydoutContext";
import { HEADER_TYPE, FOOTER_TYPE, THEME_TYPE } from "@Constants/dataEnums";


const MemberCardPage = () => {

    const user = localUser.get();
    const { displayNo } = user || {};

    const { setHeaderType, setFooterType, setThemeType } = useMainLayoutContext();

    useEffect(() => {
            setHeaderType(HEADER_TYPE.HIDE_USER | HEADER_TYPE.LOGO_CENTER | HEADER_TYPE.HIDE_BACKGROUND | HEADER_TYPE.LOGO_WHITE);
            setFooterType(FOOTER_TYPE.HIDE_BORDER_TOP | FOOTER_TYPE.FLEX);
            setThemeType(THEME_TYPE.DARK);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <Box className={'container'}>
            <MemberUserBox />
            <Stack alignItems={'center'} justifyContent={'center'} spacing={2}>
                <Card className={'barcode-box focus-card'}>
                    <BarcodeGenerator value={displayNo} options={{ displayValue: false }} />
                </Card>
            </Stack>
        </Box>
    )
}

export default MemberCardPage;